var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundbarLiveSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 35.999,
    viewBox: "0 0 20.25 35.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-pin",
    "data-name": "Icon awesome-map-pin",
    d: "M7.875,22.285V33.3l1.548,2.322a.844.844,0,0,0,1.4,0L12.375,33.3V22.285a11.872,11.872,0,0,1-4.5,0ZM10.125,0A10.125,10.125,0,1,0,20.25,10.125,10.125,10.125,0,0,0,10.125,0Zm0,5.344a4.786,4.786,0,0,0-4.781,4.781.844.844,0,0,1-1.687,0,6.476,6.476,0,0,1,6.469-6.469.844.844,0,0,1,0,1.688Z",
    fill: "#fed700"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundbarLiveSelected);
export default __webpack_public_path__ + "static/media/soundbarLiveSelected.3a03370aeff33e929f30fc6b9bc4fcfe.svg";
export { ForwardRef as ReactComponent };